var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H16V1H14V3H10V1H8V3H7C5.89 3 5.01 3.9 5.01 5L5 21C5 22.1 5.89 23 7 23H17C18.1 23 19 22.1 19 21V5C19 3.9 18.1 3 17 3ZM17 21H7V10H17V21ZM17 8H7V5H17V8ZM12 14H14V16H12V14ZM8 14H10V16H8V14ZM16 18H14V16H16V18ZM12 18H10V16H12V18ZM8 18H10V16H8V18Z",
    fill: "#B9B4CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSchedule);
export default __webpack_public_path__ + "static/media/notificationSchedule.3ae51dd7f33d7fcb51d466ecc4bf569f.svg";
export { ForwardRef as ReactComponent };